import {
  COLLECTION_LIST_GET_SUCCESS,
  CREATE_COLLECTION_SUCCESS,
  GET_COLLECTION_SUCCESS,
  SET_PAGE_VIEW,
  DELETE_COLLECTION_SUCCESS,
  GET_COLLECTION_COURSE_LIST_SUCCESS,
  COURSE_DELETE_SUCCESS,
  EDIT_COURSE_COLLECTION_INDEX_SUCCESS,
  COURSE_CLONE_SUCCESS,
  COURSE_TRANSLATE_SUCCESS,
  COURSE_TRANSLATION_COMPLETE,
  GET_COLLECTION_SETTINGS_SUCCESS,
  PATCH_COURSE_COLLECTION_SUCCESS,
  PATCH_PRICE_SUCCESS,
  PATCH_COLLECTION_SETTINGS_SUCCESS,
  PATCH_COLLECTION_PAYMENT_MESSAGES_SUCCESS,
  GET_COLLECTION_LANDING_PAGE_SUCCESS,
  PATCH_COLLECTION_LANDING_PAGE_SUCCESS,
  INVITE_COLLABORATOR_SUCCESS,
  GET_COLLECTION_COLLABORATORS_LIST_SUCCESS,
  UPDATE_COLLECTION_COLLABORATOR_SUCCESS,
  DELETE_COLLECTION_COLLABORATOR_SUCCESS,
  FILTER_COLLABORATION_COLLECTION_LIST_SUCCESS,
  ACCEPT_INVITATION_COLLABORATION_SUCCESS,
  SET_VIEW_MODE,
  DELETE_COLLECTION_INVITATION_SUCCESS,
  COLLECTION_SHOWCASE_SUCCESS,
  SET_COLLECTION_TAGS_SUCCESS,
  COLLECTION_DUPLICATING,
  COLLECTION_DUPLICATION_COMPLETE,
} from './type'
import { TAG_DELETE_SUCCESS, TAG_UPDATE_SUCCESS } from '../tag/type'
import {
  addInProgress,
  removeInProgress,
  getInProgress,
  IN_PROGRESS_OPERATIONS,
} from 'src/utils/in-progress-storage'
// eslint-disable-next-line
export default function (
  state = {
    list: [],
    teams: [],
    collection: null,
    collectionSettings: {},
    constants: null,
    pageView: 'Mini Courses',
    courses: null,
    landingPageSettings: null,
    landingPage: `<div class="simple-box-wrapper"> 
                <div class="simple-box">
                    <div class="column">
                      <h2>Heading </h2>
                      <p>I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!</p>
                      <div class="img-wrapper">
                        <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                      </div>
                    </div>
                  </div>
                </div>`,

    memberList: {},
    collaboratorsList: { results: null, totalCount: 0 },
    collaboratorCollectionList: [],
    viewMode: 'personal',
    translatingIds: [],
    // Seed from localStorage so the "Duplicating…" overlay survives a page refresh
    // even before the SignalR connection is up. Live-session updates below also
    // sync the storage on every change.
    duplicatingIds: getInProgress(IN_PROGRESS_OPERATIONS.DUPLICATION),
  },
  action,
) {
  const { payload, type } = action

  switch (type) {
    case COLLECTION_LIST_GET_SUCCESS:
      return { ...state, list: payload.results }

    case CREATE_COLLECTION_SUCCESS:
      return {
        ...state,
        list: [payload.response, ...state.list],
      }
    case DELETE_COLLECTION_SUCCESS:
      let collectionId = payload
      state = {
        ...state,
        list: state.list.filter(collection => {
          return collection.id !== collectionId
        }),
      }

      return state
    case EDIT_COURSE_COLLECTION_INDEX_SUCCESS:
      return state
    case GET_COLLECTION_SUCCESS:
      return {
        ...state,
        collection: payload,
      }
    case SET_PAGE_VIEW:
      return { ...state, pageView: payload }

    case GET_COLLECTION_COURSE_LIST_SUCCESS:
      return { ...state, courses: payload }

    case COURSE_DELETE_SUCCESS:
      return state

    case COURSE_CLONE_SUCCESS:
      return state
    case COURSE_TRANSLATE_SUCCESS:
      return {
        ...state,
        translatingIds: [...(state.translatingIds || []), payload.entity.id],
      }
    case COURSE_TRANSLATION_COMPLETE:
      return {
        ...state,
        translatingIds: (state.translatingIds || []).filter(id => id !== payload.id),
      }
    case COLLECTION_DUPLICATING:
      addInProgress(IN_PROGRESS_OPERATIONS.DUPLICATION, payload.id)
      return {
        ...state,
        duplicatingIds: [...(state.duplicatingIds || []), payload.id],
      }
    case COLLECTION_DUPLICATION_COMPLETE:
      removeInProgress(IN_PROGRESS_OPERATIONS.DUPLICATION, payload.id)
      return {
        ...state,
        duplicatingIds: (state.duplicatingIds || []).filter(
          id => id !== payload.id,
        ),
      }
    case PATCH_COURSE_COLLECTION_SUCCESS:
      const patchedCollection = { ...state.collection }
      payload.content._contents.forEach(value => {
        if (value._path === 'collectionName') {
          patchedCollection.name = value.value
        } else {
          patchedCollection[value._path] = value.value
        }
      })
      return {
        ...state,
        collection: patchedCollection,
      }
    case GET_COLLECTION_SETTINGS_SUCCESS:
      state = {
        ...state,
        collectionSettings: payload.response,
      }
      return state
    case PATCH_COLLECTION_SETTINGS_SUCCESS:
      var newCollectionSettings = state.collectionSettings
      payload.content._contents.map(value => {
        // The SMTP password is write-only: mirroring it here would leave the
        // plaintext credential sitting in the store. Track only that one exists.
        if (value._path === 'smtpPassword') {
          if (value._value) {
            newCollectionSettings.smtpHasPassword = true
          }
          return
        }
        newCollectionSettings[value._path] = value._value
      })
      state = {
        ...state,
        collectionSettings: newCollectionSettings,
      }
      return state

    case PATCH_COLLECTION_PAYMENT_MESSAGES_SUCCESS: {
      // Backend stores these on PaymentSetting; the GET surfaces them as
      // paymentMessageOnSuccess/Failure on the settings DTO. Mirror that here
      // so a re-read isn't required.
      const next = { ...state.collectionSettings }
      payload.content?._contents?.forEach(value => {
        if (value._path === 'messageOnSuccess') {
          next.paymentMessageOnSuccess = value._value
        } else if (value._path === 'messageOnFailure') {
          next.paymentMessageOnFailure = value._value
        }
      })
      return { ...state, collectionSettings: next }
    }

    case GET_COLLECTION_LANDING_PAGE_SUCCESS:
      state = {
        ...state,
        landingPageSettings: payload.response,
      }
      return state

    case PATCH_COLLECTION_LANDING_PAGE_SUCCESS:
      const updatedSettings = { ...state.landingPageSettings }

      payload.response.forEach(item => {
        updatedSettings[item.path] = item.value
      })

      // Also update the collection in the list if thumbnail is being updated
      const thumbnailUpdate = payload.response.find(
        item => item.path === 'thumbnail',
      )
      const updatedList = thumbnailUpdate
        ? state.list.map(collection =>
            collection.id === payload.collectionId
              ? { ...collection, thumbnail: thumbnailUpdate.value }
              : collection,
          )
        : state.list

      return {
        ...state,
        landingPageSettings: updatedSettings,
        list: updatedList,
      }
    case INVITE_COLLABORATOR_SUCCESS:
      const newCollaborator = {
        email: payload.response.email,
        name: '-',
        role: 'Pending',
        status: 1,
      }
      return {
        ...state,
        collaboratorsList: {
          results: [...state.collaboratorsList.results, newCollaborator],
          totalCount: state.collaboratorsList.totalCount + 1,
        },
      }
    case GET_COLLECTION_COLLABORATORS_LIST_SUCCESS:
      return {
        ...state,
        collaboratorsList: {
          results: payload.response.results,
          totalCount: payload.response.totalCount,
        },
      }
    case UPDATE_COLLECTION_COLLABORATOR_SUCCESS:
      const { userId, data } = payload
      return {
        ...state,
        collaboratorsList: {
          results: state.collaboratorsList.results.map(collaborator =>
            collaborator.userId === userId
              ? { ...collaborator, ...data }
              : collaborator,
          ),
          totalCount: state.collaboratorsList.totalCount,
        },
      }
    case DELETE_COLLECTION_COLLABORATOR_SUCCESS:
      const newResults = state.collaboratorsList.results.filter(
        collaborator => collaborator.userId !== payload.response,
      )
      return {
        ...state,
        collaboratorsList: {
          results: newResults,
          totalCount: state.collaboratorsList.totalCount - 1,
        },
      }
    case FILTER_COLLABORATION_COLLECTION_LIST_SUCCESS:
      return {
        ...state,
        collaboratorCollectionList: payload.response.results,
      }
    case ACCEPT_INVITATION_COLLABORATION_SUCCESS:
      return state
    case SET_VIEW_MODE:
      return { ...state, viewMode: payload }
    case DELETE_COLLECTION_INVITATION_SUCCESS:
      return {
        ...state,
        collaboratorsList: {
          results: state.collaboratorsList.results.filter(
            collaborator => collaborator.email !== payload.response,
          ),
          totalCount: state.collaboratorsList.totalCount - 1,
        },
      }
    case COLLECTION_SHOWCASE_SUCCESS:
      return {
        ...state,
        // Always the portal (type 1): without it, the page opened as a path
        // until the full collection loaded.
        collection: { ...payload.response, type: 1 },
      }
    case PATCH_PRICE_SUCCESS:
      return {
        ...state,
        collectionSettings: {
          ...state.collectionSettings,
          price: {
            amount: payload.content.amount,
            currency: payload.content.currency,
            paymentProvider: payload.content.paymentProvider,
            priceMetadata: payload.content.priceMetadata,
            priceType: payload.content.priceType,
          },
        },
      }
    case SET_COLLECTION_TAGS_SUCCESS: {
      const { collectionId: targetId, tags } = payload
      const patch = collection =>
        collection.id === targetId ? { ...collection, tags } : collection
      return {
        ...state,
        list: state.list.map(patch),
        collaboratorCollectionList: state.collaboratorCollectionList.map(patch),
      }
    }
    case TAG_DELETE_SUCCESS: {
      const removedId = payload
      const stripTag = collection =>
        collection.tags && collection.tags.some(t => t.id === removedId)
          ? { ...collection, tags: collection.tags.filter(t => t.id !== removedId) }
          : collection
      return {
        ...state,
        list: state.list.map(stripTag),
        collaboratorCollectionList: state.collaboratorCollectionList.map(stripTag),
      }
    }
    case TAG_UPDATE_SUCCESS: {
      const updatedTag = payload
      if (!updatedTag) return state
      const patchTag = collection =>
        collection.tags && collection.tags.some(t => t.id === updatedTag.id)
          ? {
              ...collection,
              tags: collection.tags.map(t =>
                t.id === updatedTag.id ? { ...t, ...updatedTag } : t,
              ),
            }
          : collection
      return {
        ...state,
        list: state.list.map(patchTag),
        collaboratorCollectionList: state.collaboratorCollectionList.map(patchTag),
      }
    }
    default:
      return state
  }
}
